module.exports = __webpack_public_path__ + "static/media/smartphone.a273f766.png";